import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from './../http-client/http-client.service';

@Injectable()
export class PermissionService {

    constructor(
        private http: HttpClientService
    ) { }

    public getAll() {
        const url: string = 'permissions/all';
        return this.http.get(url).map(response => response.json())
        .catch(this.handleError);
    }

    public getByApplicationRoleId(applicationRoleId: string) {
        const url: string = 'permissions/application-role/id/' + applicationRoleId;
        return this.http.get(url).map(response => response.json())
        .catch(this.handleError);
    }

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/permissions/permission.service.ts